module.exports = __webpack_public_path__ + "img/trophy.7a64b861.gif";